<template>
  <v-container class="pt-0" v-if="promotion" fluid>
    <v-row>
      <v-col
        :class="$vuetify.breakpoint.xsOnly ? 'background-color-white' : ''"
        cols="12"
        md="7"
        lg="8"
        xl="9"
      >
        <div class="align-center d-flex">
          <Title
            :icon="'mdi-label-percent-outline'"
            :sub="promotion.department_name"
            :text="'Deals'"
          />
        </div>
        <v-row no-gutters>
          <v-col>
            <a
              class="align-center background-color-seashell d-inline-flex font-size-sm nav-button-border-radius pl-1 pr-3"
              @click="$router.push({ name: 'deals' })"
            >
              <v-icon color="primary">mdi-chevron-left</v-icon>
              Back to Deals Page
            </a>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="5" lg="4" xl="3">
        <PromotionSort />
      </v-col>
    </v-row>
    <Loader :loaded="promotionLoaded" :marginTop="20" />
    <v-row class="background-color-white mb-0 mb-sm-6 mr-sm-0 px-3 px-sm-6">
      <v-col
        v-for="product in promotion.products"
        class="position-relative"
        :key="product.upc"
        cols="6"
        md="4"
        xl="3"
      >
        <Product
          :product="product"
          :size="$vuetify.breakpoint.xsOnly ? 'xs' : 'md'"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import throttle from "lodash.throttle";
import Loader from "@/components/UI/Loader.vue";
import Product from "@/components/Product/index.vue";
import PromotionSort from "@/components/Promotion/Sort.vue";
import Title from "@/components/UI/Title.vue";

export default {
  name: "Promotion",
  components: {
    Loader,
    Product,
    PromotionSort,
    Title,
  },
  computed: {
    ...mapGetters("promotion", {
      promotionLoaded: "loaded",
    }),
    ...mapState({
      promotion: (state) => state.promotion.data,
    }),
  },
  created() {
    document.addEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      fetching: true,
    };
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    checkIfNeedMoreProducts() {
      const pixelsFromBottomToMakeAnotherRequest = 890;
      const scrollHeight = document.body.clientHeight;
      const scrollPos = window.innerHeight + window.scrollY;
      const timeToFetch =
        (scrollHeight - pixelsFromBottomToMakeAnotherRequest >= scrollPos) /
          scrollHeight ===
        0;
      if (timeToFetch && !this.fetching) {
        this.$store.commit("promotion/UPDATE_PAGE");
        this.$store.dispatch(
          "promotion/fetch",
          this.$route.params.promotionDepartmentId
        );
      }
    },
    handleScroll: throttle(function () {
      this.checkIfNeedMoreProducts();
    }, 300),
  },
  watch: {
    "$route.params.promotionDepartmentId": {
      handler: async function (promotionDepartmentId) {
        await this.$store.dispatch("promotion/fetch", promotionDepartmentId);
        this.fetching = false;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
